import React, {useEffect, useState} from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";

const TripDurationSearch = ({onDurationChange, initialState = {min: 1, max: 14}, externalDurationChange}) => {
  const [value, setValue] = useState(initialState);
  useEffect(() => {
    if (externalDurationChange) {
      setValue(externalDurationChange)
    }
  }, [externalDurationChange])

  return (
    <>
      <div className="searchMenu-loc px-24 lg:py-20 lg:px-0 js-form-dd js-liverSearch">
        <div
          data-bs-toggle="dropdown"
          data-bs-auto-close="true"
          data-bs-offset="0,22"
        >
          <h4 className="text-15 fw-500 ls-2 lh-16" id="trip-duration-label">Długość podróży</h4>
          <div className="text-15 text-light-1 ls-2 lh-16">
            <InputRange
              maxValue={18}
              minValue={1}
              value={value}
              onChange={(val) => {
                  setValue(val)
                onDurationChange(val)
              }}
              formatLabel={() => ""}
              ariaLabelledby="trip-duration-label"
            />
            <p>
              {value.min} - {value.max} dni</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TripDurationSearch;